module.exports = __webpack_public_path__ + "static/media/8.ca9c983e.jpg";